@if (dashboardEmbedUrl$ | async; as embedUrl) {
  <iframe class="h-full w-full" [src]="embedUrl"></iframe>
} @else {
  <app-loading-animation
    class="absolute w-full h-full bg-navy-30"
    [width]="'270px'"
    [height]="'270px'"
  ></app-loading-animation>
}
